import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaWhatsapp, FaInstagram, FaFacebook, FaLinkedin, FaTimes } from 'react-icons/fa';
import './SocialButtons.css';

const SocialButtons = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useTranslation();

  return (
    <div className={`social-buttons ${isExpanded ? 'expanded' : ''}`}>
      <button
        type="button"
        className="social-toggle"
        onClick={() => setIsExpanded(!isExpanded)}
        aria-label={t('social.toggle')}
      >
        {isExpanded ? <FaTimes /> : <span>{t('social.followUs')}</span>}
      </button>

      {isExpanded && (
        <div className="social-icons-container">
          <a
            href="https://wa.me/212669032828"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon whatsapp"
            aria-label={t('common.whatsapp')}
          >
            <FaWhatsapp />
            <span>{t('common.whatsapp')}</span>
          </a>
          <a
            href="https://www.instagram.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon instagram"
            aria-label={t('common.instagram')}
          >
            <FaInstagram />
            <span>{t('common.instagram')}</span>
          </a>
          <a
            href="https://www.facebook.com/profile.php?id=61590350775330"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon facebook"
            aria-label={t('common.facebook')}
          >
            <FaFacebook />
            <span>{t('common.facebook')}</span>
          </a>
          <a
            href="https://www.linkedin.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon linkedin"
            aria-label={t('common.linkedin')}
          >
            <FaLinkedin />
            <span>{t('common.linkedin')}</span>
          </a>
        </div>
      )}
    </div>
  );
};

export default SocialButtons;
